import { createSvgIcon } from '@mui/material/utils';
import React, { memo } from 'react';

const SvgIcon = createSvgIcon(
  [
    <defs key='0'>
      <clipPath id='transportMarkerClip'>
        <path id='transportMarkerShape' d='M12,2L4.5,20.3L12,18l7.5,2.3L12,2z' />
      </clipPath>
    </defs>,
    <use key='1' xlinkHref='#transportMarkerShape' fill='none' stroke='#000000' />,
    <use key='2' xlinkHref='#transportMarkerShape' stroke='#ffffff' clipPath='url(#transportMarkerClip)' />,
  ],
  'TransportMarker'
);

const TransportMarkerIcon = function (props) {
  return (
    <SvgIcon
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
      sx={{
        'path:nth-of-type(3)': {
          fill: props.htmlColor,
        },
      }}
      {...props}
    />
  );
};

export default memo(TransportMarkerIcon);
